import { post } from '../index';

export const authorize = data => {
  return post('/users/login', data);
};
